import React from "react";
import { Link } from 'react-router-dom';

function Footer(props) {
    return (
        <footer className="footer">
            <div className="footer-content">
                <span className="footer-text">QRC<span className="footer-text-green">B</span><span className="footer-text-yellow">R</span></span>
                <span className="footer-text-min">A solução mais completa de Qr Code</span>
            </div>
            <div className="footer-links">
                <span className="footer-text-min">Leia nossos </span>
                <Link to="/terms-of-service">Termos de Serviço</Link>
                <span className="footer-text-min"> e nossa </span>
                <Link to="/privacy-policy">Política de Privacidade</Link>
            </div>
        </footer>
    );
}

export default Footer;